import styled from 'styled-components';
import {flexColumn, dFlex, dFlexEnd} from '../../../../../../../globalVariables/GlobalFlex';
import {btn} from '../../../../../../../component/button/btn/Btn.css';
import {icon} from '../../../../../../../component/classes/input';

export const wrap = styled.div`
    ${flexColumn};
    padding: 12px;
    width: 100%;
    gap: 12px;
    height: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    ${icon}{
        width:unset;
        height:unset;
    }
`;

export const buttonsWrapper = styled.div`
    ${dFlex};
    ${dFlexEnd};
    gap: 12px;
    margin-top: auto;
    ${btn}:first-child {
        margin-right: auto;
    }
`;

